import { render, staticRenderFns } from "./GuestCard.vue?vue&type=template&id=64fbc004&"
import script from "./GuestCard.vue?vue&type=script&lang=js&"
export * from "./GuestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports